// extracted by mini-css-extract-plugin
export default {"root":"EditDurationModalUpdateStage_root__OQUIc","updated":"EditDurationModalUpdateStage_updated__btwFd","updatedDuration":"EditDurationModalUpdateStage_updatedDuration__q0eFE"};